import { useT } from "../i18n/hooks.ts";

/**
 * One-time notice shown right after the "MITECO" wizard tab finishes
 * (Step1SubBasins.tsx/App.tsx's `onComplete` handler): its AEMET fetch for
 * the newly-imported sub-basins keeps running in the background exactly
 * like any other queued job (aemetJobStore.ts, see AemetJobsPopover.tsx for
 * the ongoing per-job progress), but a user who just finished a wizard
 * without picking anything else might not otherwise realize something is
 * still happening. Dismissible, not persistent like ExampleBanner.tsx —
 * once acknowledged there's no need to keep repeating it, the top bar's own
 * AEMET jobs badge already carries the ongoing status from here on.
 */
export function MitecoAemetBanner({ onDismiss }: { onDismiss: () => void }) {
  const t = useT();
  return (
    <div className="ephemeral-banner miteco-aemet-banner">
      <span>{t("mitecoAemetBanner.warning")}</span>
      <button
        className="button-icon"
        onClick={onDismiss}
        aria-label={t("common.close")}
        title={t("common.close")}
      >
        ✕
      </button>
    </div>
  );
}
